








import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import Chart from 'chart.js';
import _merge from 'lodash/merge';
import _debounce from 'lodash/debounce';
import { utilService } from '../util-service';
import chartUtil from './util.service';
import SwChartChartJsMixin from './sw-chart-chart-js.mixin.vue';

@Component
export default class SwChartPie extends mixins(SwChartChartJsMixin) {
  @Prop({ type: Array, default () { return []; } })
  chartData: Chart.ChartDataSets[];

  @Prop({ type: Array })
  highlightSlice: [number, number] | undefined; // [datasetIndex, dataIndex]

  @Prop(Array)
  labels: string[];

  @Prop({ type: Array, default() { return utilService.colorConst.chartPrimaryPalette; } })
  colorPalette: string[];

  selected = -1;
  datasetIndex = -1;
  highlightTrigger = 1;

  get chartOptions(): Chart.ChartOptions {
    const options: Chart.ChartOptions = {
      legend: {
        display: false,
      },
      onHover: (evt, elems) => {// tslint:disable-line
        if (this.chartInstance) {
          const evtPoint = elems as any[];
          if (evtPoint && evtPoint.length > 0) {
            this.datasetIndex = evtPoint[0]._datasetIndex;
            this.selected = evtPoint[0]._index;
            this.debouncedHighlightDefault.cancel();
          } else {
            this.selected = -1;
            this.datasetIndex = -1;
            this.highlightTrigger += 1;
          }
        }
      },
      tooltips: {
        enabled: true,
        intersect: true,
      },
    };
    return _merge(options, this.options);
  }

  get dataSetOption() {
    return {
      borderColor: chartUtil.elementBorderColor(this.theme),
      hoverBorderColor: utilService.colorConst.selected,
      backgroundColor: this.colorPalette,
    };
  }

  get normalizedDatasets() {
    return this.chartData.map((dataset: Chart.ChartDataSets) => {
      return Object.assign({}, dataset, this.dataSetOption);
    });
  }

  private updateData() {
    if (this.chartInstance) {
      chartUtil.updateChartRegularData(this.chartInstance, this.labels, this.normalizedDatasets);
    }
  }

  @Watch('labels')
  @Watch('theme')
  @Watch('normalizedDatasets')
  @Watch('chartOptions')
  private onConfigChanged() {
    if (this.chartInstance) {
      this.updateData();
      (this.chartInstance as any).options = this.chartOptions;
      this.chartInstance.update();

      if (Array.isArray(this.highlightSlice) && this.selected === this.highlightSlice[1] && this.datasetIndex === this.highlightSlice[0]) {
        this.highlightDefault();
      } else if (this.selected < 0 && this.datasetIndex < 0) {
        this.debouncedHighlightDefault();
      } else {
        this.debouncedHighlightDefault.cancel();
      }
    }
  }

  @Watch('highlightTrigger')
  private onHighlightTrigger() {
    this.debouncedHighlightDefault();
  }

  @Watch('highlightSlice')
  private onHighlightSliceChange() {
    this.selected = -1;
    this.datasetIndex = -1;
    this.dbDebouncedHighlightDefault();
  }

  private highlightDefault() {
    if (Array.isArray(this.highlightSlice) && this.chartInstance) {
      if (!(
        this.selected < 0 || this.datasetIndex < 0 ||
        (this.selected === this.highlightSlice[1] && this.datasetIndex === this.highlightSlice[0])
      )) { return; }
      const datasetMeta = this.chartInstance.getDatasetMeta(this.highlightSlice[0]);
      if (!datasetMeta) { return; }
      const pointMeta = datasetMeta.data[this.highlightSlice[1]];
      if (!pointMeta) { return; }

      const point: { x: number; y: number; } = (pointMeta as any).getCenterPoint();
      const rect = this.chartInstance.canvas!.getBoundingClientRect();
      this.chartInstance.canvas!.dispatchEvent(
        new MouseEvent('mousemove', {
          clientX: rect.left + point.x,
          clientY: rect.top + point.y,
        }),
      );
    }
  }
  private get debouncedHighlightDefault() {
    return  _debounce(this.highlightDefault, 500);
  }
  private get dbDebouncedHighlightDefault() {
    return  _debounce(this.debouncedHighlightDefault, 400);
  }

  private created() {
    this.myCssPrefix = 'sw-chart-pie';
  }

  private mounted() {
    this.initChart({
      type: 'pie',
      data: {
        labels: this.labels,
        datasets: this.normalizedDatasets,
      },
      options: this.chartOptions,
    });

    setTimeout(this.highlightDefault, 500);
  }

  protected beforeDestroy() {
    this.dbDebouncedHighlightDefault.cancel();
    this.debouncedHighlightDefault.cancel();
  }
}
